import { lazy, Suspense, useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";

const BelowFold = lazy(() => import("@/components/BelowFold"));

export default function HomePage() {
  const [showBelow, setShowBelow] = useState(false);

  useEffect(() => {
    const load = () => setShowBelow(true);
    if ("requestIdleCallback" in window) {
      const id = window.requestIdleCallback(load, { timeout: 3000 });
      return () => window.cancelIdleCallback(id);
    }
    const t = setTimeout(load, 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        {showBelow && (
          <Suspense fallback={null}>
            <BelowFold />
          </Suspense>
        )}
      </main>
    </>
  );
}
